module.exports = __webpack_public_path__ + "static/media/main-logo-white.26774081.svg";